import { render, staticRenderFns } from "./puzzle_order.vue?vue&type=template&id=568ecd65&scoped=true&"
import script from "./puzzle_order.vue?vue&type=script&lang=js&"
export * from "./puzzle_order.vue?vue&type=script&lang=js&"
import style0 from "./puzzle_order.vue?vue&type=style&index=0&id=568ecd65&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568ecd65",
  null
  
)

export default component.exports